import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from 'react';

import type { SuggestionProps } from '@tiptap/suggestion';
import { useReduxState } from 'hooks';

const RichTextEditorTemplateTagsSuggestions = forwardRef(
  (props: SuggestionProps, ref) => {
    const { theme } = useReduxState();

    const [selectedIndex, setSelectedIndex] = useState(0);

    const selectItem = (index) => {
      const item = props.items[index];

      if (item) {
        props.command({ key: item.key });
      }
    };

    const upHandler = () => {
      setSelectedIndex(
        (selectedIndex + props.items.length - 1) % props.items.length
      );
    };

    const downHandler = () => {
      setSelectedIndex((selectedIndex + 1) % props.items.length);
    };

    const enterHandler = () => {
      selectItem(selectedIndex);
    };

    useEffect(() => setSelectedIndex(0), [props.items]);

    useImperativeHandle(ref, () => ({
      onKeyDown: ({ event }) => {
        if (event.key === 'ArrowUp') {
          upHandler();
          return true;
        }

        if (event.key === 'ArrowDown') {
          downHandler();
          return true;
        }

        if (event.key === 'Enter') {
          enterHandler();
          return true;
        }

        return false;
      }
    }));

    if (!props.items.length) return null;

    return (
      <div className="dropdown-menu">
        {props.items.map((item, index) => (
          <button
            className={`dropdown-menu-button ${
              index === selectedIndex ? 'is-selected' : ''
            }`}
            key={index}
            onClick={() => selectItem(index)}
          >
            {item.key}
          </button>
        ))}

        <style jsx>{`
          .dropdown-menu {
            background-color: white;
            border-radius: ${theme.dropdownBorderRadius};
            box-shadow: ${theme.dropdownShadow};
            padding: 3px;
            position: relative;
            top: -5px;
            z-index: 300;
          }
          .dropdown-menu-button {
            background-color: white;
            border: 0;
            border-radius: ${theme.buttonBorderRadius};
            color: ${theme.textColorLight};
            cursor: pointer;
            display: flex;
            font-family: inherit;
            font-size: 1.4rem;
            font-weight: 600;
            margin: 0;
            outline: 0;
            padding: 5px 10px;
            position: relative;
            transition: background-color 0.3s, color 0.3s;
            width: 100%;
          }
          .dropdown-menu-button.is-selected {
            color: ${theme.textColor};
            background-color: ${theme.lightGreyLighter};
          }
          .empty {
            color: ${theme.textColorLighter};
            font-size: 1.4rem;
            padding: 2px 5px;
          }
        `}</style>
      </div>
    );
  }
);

RichTextEditorTemplateTagsSuggestions.displayName =
  'RichTextEditorTemplateTagsSuggestions';

export default RichTextEditorTemplateTagsSuggestions;
